import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Lock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="font-heading font-bold text-xl text-primary dark:text-white">
                Kenmerk<span className="text-accent">Check.nl</span>
              </span>
            </Link>
            <p className="text-slate-500 dark:text-slate-400 text-sm max-w-md mb-4">
              {t('footer_disclaimer')}
            </p>
            <div className="flex items-center gap-4 text-slate-400">
              <div className="flex items-center gap-2 text-xs">
                <Shield className="w-4 h-4" />
                <span>Privacy First</span>
              </div>
              <div className="flex items-center gap-2 text-xs">
                <Lock className="w-4 h-4" />
                <span>Geen opslag</span>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-slate-900 dark:text-white mb-4">
              Tool
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  Decoder
                </Link>
              </li>
              <li>
                <Link to="/bulk" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  Bulk Decoder
                </Link>
              </li>
              <li>
                <Link to="/bank" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  Bank Upload
                </Link>
              </li>
              <li>
                <Link to="/uitleg" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  Uitleg
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-sm text-slate-900 dark:text-white mb-4">
              Legal
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/pricing" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  {t('nav_pricing')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  {t('footer_privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-500 dark:text-slate-400 hover:text-accent text-sm transition-colors">
                  {t('footer_terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 dark:border-slate-800 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} KenmerkCheck. All rights reserved.
          </p>
          <p className="text-slate-400 text-xs">
            Made with precision for Dutch tax professionals
          </p>
        </div>
      </div>
    </footer>
  );
};
